import {Spinner} from '@primer/react'
import {Dialog} from '@primer/react/experimental'
import type {RefObject} from 'react'

import ChecksStatusBadgeFooter from './components/ChecksStatusBadgeFooter'
import HeaderState from './components/ChecksStatusBadgeHeader'
import {PendingWorkflowApprovalBanner} from './components/PendingWorkflowApprovalBanner'
import type {CombinedStatusResult} from './index'

import styles from './CheckStatusDialog.module.css'

interface CheckStatusDialogProps {
  combinedStatus?: CombinedStatusResult
  isOpen: boolean
  onDismiss: () => void
  repositoryNwo?: string
  onWorkflowsApproved?: () => void
  /** Element to focus when the dialog closes, e.g. the control that opened it. */
  returnFocusRef?: RefObject<HTMLElement | null>
}

export function CheckStatusDialog(props: CheckStatusDialogProps) {
  const {combinedStatus, isOpen, onDismiss, repositoryNwo, onWorkflowsApproved, returnFocusRef} = props

  const title = combinedStatus ? <HeaderState checksHeaderState={combinedStatus.checksHeaderState} /> : 'Loading...'

  const pendingApproval = combinedStatus?.pendingWorkflowApproval
  const approvalBanner =
    pendingApproval && pendingApproval.workflowsRequiringApprovalCount > 0 && repositoryNwo ? (
      <PendingWorkflowApprovalBanner
        pendingWorkflowApproval={pendingApproval}
        repositoryNwo={repositoryNwo}
        onApproved={onWorkflowsApproved}
      />
    ) : null

  return isOpen ? (
    <Dialog
      onClose={onDismiss}
      title={title}
      subtitle={combinedStatus ? combinedStatus.checksStatusSummary : undefined}
      width="xlarge"
      returnFocusRef={returnFocusRef}
      renderBody={() => (
        <Dialog.Body className={styles.Dialog_Body}>
          {approvalBanner}
          {combinedStatus ? (
            <ChecksStatusBadgeFooter checkRuns={combinedStatus.checkRuns} />
          ) : (
            <div className={styles.Box}>
              <Spinner size="medium" />
            </div>
          )}
        </Dialog.Body>
      )}
      className={styles.Dialog}
    />
  ) : null
}
